

























import { Component, Vue } from "vue-property-decorator";
import AuthService from "@/services/auth.service";

@Component
export default class App extends Vue {
  private get user() {
    return this.$typedStore.state.device.settings.userId;
  }
  private get company() {
    return this.$typedStore.state.device.settings.clientName;
  }

  private logout() {
    return AuthService.signOut();
  }
}
